import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import http from "../utils/http";
import { errorToastMessage } from "../utils/toast";

export function useStudyParticipantFilterOptions(studyId: string | undefined) {
  const [cohortList, setCohortList] = useState<{ id: string; label: string }[]>(
    [],
  );
  const [tagList, setTagList] = useState<{ id: string; label: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!studyId) return;
      try {
        setLoading(true);
        const [cohortRes, tagRes]: [AxiosResponse, AxiosResponse] =
          await Promise.all([
            http.get(`/study/${studyId}/participant-groups?page=1&size=100`),
            http.get(`/platform-tags`),
          ]);

        const cohortData = cohortRes.data?.data?.data?.map((item: any) => ({
          id: item?.id,
          label: item?.name || "",
        }));
        setCohortList(cohortData || []);

        const tagData = tagRes.data?.data?.map((item: any) => ({
          id: item?.id,
          label: item?.name || "",
        }));
        setTagList(tagData || []);
      } catch (error) {
        errorToastMessage(error as Error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [studyId]);

  return { cohortList, tagList, loading };
}
